'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryParam = undefined;

var _prop = require('lodash/fp/prop');

var _prop2 = _interopRequireDefault(_prop);

var _Maybe = require('../fp/type/Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

var _maybe = require('../fp/maybe');

var _maybe2 = _interopRequireDefault(_maybe);

var _windowIO = require('../IO/windowIO');

var _windowIO2 = _interopRequireDefault(_windowIO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get value of given query parameter from current location.
  * */
var getQueryParam = exports.getQueryParam = function getQueryParam(paramName) {
  var regexp = new RegExp('(^|&)' + paramName + '=([^&]*)(&|$)', 'i');
  return _windowIO2.default.map((0, _prop2.default)('location')).map((0, _prop2.default)('search')).map(function (search) {
    return search.substr(1);
  }).map(function (querys) {
    return querys.match(regexp);
  }).map(_Maybe2.default.of).map((0, _maybe2.default)(undefined, function (matchedGroups) {
    return matchedGroups[2];
  })).unsafePerformIO();
};